import AniLink from "gatsby-plugin-transition-link/AniLink"
import React from "react"
import Transition from "../pages/transition"

const CaseStudyFooterNavSection = ({
  title,
  about = "",
  subtitle,
  to,
  className,
  isMobile,
}) => (
  <>
    <section className={`${className} case-study-margin`}>
      <AniLink
        cover
        direction="down"
        bg="#000000"
        duration={1}
        to={to}
        className="text-white"
        target="_blank"
      >
        <div className="container py-5">
          <div
            className="row align-content-between"
            style={isMobile ? { minHeight: "300px" } : { minHeight: "400px" }}
          >
            <div className="col-md-12 mt-auto px-md-5 px-4">
              <Transition
                data={
                  <>
                    <h1 className="text-white">{title}</h1>
                    <p
                      className="text-white d-md-block d-none"
                      style={{ lineHeight: 1 }}
                    >
                      {about}
                      <br />
                      {subtitle}
                    </p>
                  </>
                }
              ></Transition>
            </div>
            <div className="col-md-12 mt-auto pb-5 d-md-block d-none px-5">
              <Transition
                data={
                  <>
                    <p className="" style={{ fontWeight: "bold" }}>
                      <AniLink
                        cover
                        direction="down"
                        bg="#000000"
                        duration={1}
                        to={to}
                        className="text-white"
                        target="_blank"
                      >
                        View Case Study
                      </AniLink>
                    </p>
                  </>
                }
              ></Transition>
            </div>
          </div>
        </div>
      </AniLink>
    </section>
  </>
)

export default CaseStudyFooterNavSection
